import {Pipe, PipeTransform} from '@angular/core';
import {MomentPipe} from '../moment/moment.pipe';
import {Period} from '../../generated/sales-terminal-client';
import {UtilService} from '../../services/util/util.service';
import {ViewService} from '../../services/view/view.service';
import {TranslateService} from '@ngx-translate/core';

interface PeriodFormat {
  date?: string;
  time?: string;
  tz?: string;
  splitter?: string;
  hasTimeInPeriod?: boolean;
  forcePeriod?: boolean;
  weekday?: boolean;
  threeDotsIfEmpty?: boolean;
  useDateNoWrap?: boolean;
}

@Pipe({
  name: 'period'
})
export class PeriodPipe implements PipeTransform {
  constructor(private momentPipe: MomentPipe,
              private utilService: UtilService,
              private viewService: ViewService,
              private translateService: TranslateService) {}

  transform(value: {start: number | string, end: number | string} | Period,
            format: PeriodFormat = {}): string {

    const isSameDay: boolean = this.isPeriodSameDay(value.start, value.end);
    if (!format.date) {
      format.date = this.viewService.conf.dateFormatWithWeekday;
    }
    if (!format.time) {
      format.time = this.viewService.conf.timeFormat;
    }
    if (!format.splitter) {
      format.splitter = ' ';
    }
    if (isSameDay && format.weekday) {
      format.date = 'ddd ' + format.date;
    }

    let start: string = this.transformToFormattedString(value.start, format, format.threeDotsIfEmpty);
    let end: string = this.transformToFormattedString(value.end, format, format.threeDotsIfEmpty);

    if (isSameDay && !format?.forcePeriod) {
      if (!format.hasTimeInPeriod) {
        start += this.momentPipe.transform(value.start, { format: format.splitter + format.time, tz: format.tz });
        if (value.end) {
          end = '';
        }
      } else if (value.end) {
        end = this.momentPipe.transform(value.end, { format: format.time, tz: format.tz });
      }
    }
    return start + (end ? ' ' + this.viewService.periodSeparator + ' ' + end : '');
  }

  private transformToFormattedString(value: number | string, format: PeriodFormat, useThreeDots?: boolean): string {
    if (!value) {
      return useThreeDots ? '...' : this.translateService.instant('general.api_period_date_undefined');
    }
    const output = this.momentPipe.transform(value, { format: format.date + (format.hasTimeInPeriod ? format.splitter + format.time : ''), tz: format.tz });
    return format.useDateNoWrap ? '<span class="white-space-no-wrap">' + output + '</span>' : output;
  }

  public isPeriodSameDay(start: number | string, end: number | string): boolean {
    return this.utilService.isPeriodSameDay(start, end);
  }
}
